import { render, staticRenderFns } from "./Persona.vue?vue&type=template&id=f4a5cebe&scoped=true"
import script from "./Persona.vue?vue&type=script&lang=js"
export * from "./Persona.vue?vue&type=script&lang=js"
import style0 from "./Persona.vue?vue&type=style&index=0&id=f4a5cebe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a5cebe",
  null
  
)

export default component.exports